export default function Services(props) {

  return (
    <article id="tjanster" className="invert">
      <section>
        <h2  id="tjanster_title">Tjänster</h2>
        <p>
          Vi hjälper er med bland annat följande tjänster:
        </p>
        <ul>
          <li>Kaminer</li>
          <li>Vedspisar</li>
          <li>Kakelugnar</li>
          <li>Bakugnar</li>
          <li>Renovering av rökkanaler</li>
          <li>Mur & putsarbeten</li>
          <li>Renovering av skorstenar</li>
          <li>Installation av rökkanaler</li>
          <li>Installation av eldstäder</li>
          <li>Byggnation av eldstäder</li>
        </ul>
      </section>
      <section>
        <h3>Renovera kanal med glidgjutning</h3>
        <p className="media">
          <img src="/images/glidgjutning.png" alt="Glidgjutning av rökkanal" width="200"/>
          En glidgjutning görs i befintliga rökkanaler med en keramisk tätningsmassa. Fördelen med denna metod är att man renoverar den befintliga rökkanalen eller ventilationskanalen så den bibehåller sin ordinarie area och värmespridning i murstocken.
        </p>
      </section>
      <section>
        <h3>Renovera kanal med flexibelt insatsrör</h3>
        <p className="media">
          <img src="/images/insatsror.png" alt="Insats rör i rökkanal" width="200"/>
          Insatsrör i rökkanal är en effektiv reparationsmetod, instasrör betyder att man monterar ett rostfritt, syrafast och böjbart rör i befintliga rökkanalen. Utrymmet mellan röret och rökkanalen fyllt med vermikulit så att man isolerar värmen runt röret och motverkar värmespridning.
        </p>
      </section>
    </article>
  )

}